import axios from 'axios'

const LfItemCategoryService = {
  async getList (params = {}) {
    return axios.get('admin/lf-item-categories', { params })
  },

  async show (id) {
    return axios.get(`admin/lf-item-categories/${id}`)
  },

  async store (data) {
    return axios.post('admin/lf-item-categories', data)
  },

  async update (id, data) {
    return axios.put(`admin/lf-item-categories/${id}`, data)
  },

  async destroy (id) {
    return axios.delete(`admin/lf-item-categories/${id}`)
  }
}

export default LfItemCategoryService
